var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectSeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: 4750,
    y: 705,
    width: 18,
    height: 10,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "flood",
    floodColor: ""
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4768,706.263L4766.73,705l-7.74,7.509-0.83-.8v0l-6.88-6.67-1.28,1.244c1.9,1.844,7.21,6.992,8.99,8.713C4760.31,713.72,4759.02,714.967,4768,706.263Z",
    transform: "translate(-4750 -705)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectSeta);
export default __webpack_public_path__ + "static/media/select-seta.e4851f4fd4d1f03bf923ee530b8dab67.svg";
export { ForwardRef as ReactComponent };